import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'https://ticobaterias.com/api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await axios.post(`${API}/auth/login`,
        new URLSearchParams({ username: email, password }),
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
      );
      localStorage.setItem('token', res.data.access_token);
      localStorage.setItem('nombre', res.data.nombre);
      navigate('/');
    } catch {
      setError('Credenciales incorrectas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-azul-dark flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="font-bold text-3xl text-white mb-2">
            Tico<span className="text-rojo">Baterías</span>®
          </div>
          <div className="text-white/40 text-sm">Panel Administrativo</div>
        </div>
        <div className="bg-white rounded-2xl p-8 shadow-2xl">
          <h1 className="font-bold text-2xl text-azul mb-6">Iniciar sesión</h1>
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-600 text-sm px-4 py-3 rounded-lg mb-4">
              {error}
            </div>
          )}
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label className="text-xs font-bold text-gray-500 tracking-wider block mb-2">CORREO</label>
              <input type="email" required value={email} onChange={e => setEmail(e.target.value)}
                placeholder="admin@ticobaterias.com"
                className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-azul"/>
            </div>
            <div>
              <label className="text-xs font-bold text-gray-500 tracking-wider block mb-2">CONTRASEÑA</label>
              <input type="password" required value={password} onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-azul"/>
            </div>
            <button type="submit" disabled={loading}
              className="w-full bg-azul text-white py-3 rounded-xl font-bold hover:bg-azul-dark transition-colors disabled:opacity-50">
              {loading ? 'Iniciando...' : 'Entrar al panel'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
